var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormulateInput',_vm._b({staticClass:"p-0",attrs:{"validation-behavior":"live","name":`${_vm.field.name}-${_vm.id}-${_vm.index}`,"label":null,"help":true,"value":_vm.computedValue},on:{"input":_vm.handleInput}},'FormulateInput',_vm.field,false))
}
var staticRenderFns = []

export { render, staticRenderFns }